
import { Component, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { asyncScheduler, forkJoin, scheduled } from 'rxjs';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import * as Highcharts from "highcharts/highmaps";
import { Chart } from 'chart.js';
import { MatMenuTrigger } from '@angular/material/menu';
import { RaiseInComponent } from '../qms/raise-in/raise-in.component';
import { RaiseCcComponent } from '../qms/raise-cc/raise-cc.component';
import { GeolocationService } from '@ng-web-apis/geolocation';
const worldMap = require('@highcharts/map-collection/custom/world.geo.json');
import proj4 from 'proj4';
import { TopNavigationComponent } from '../top-navigation/top-navigation.component';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { AuService } from '../qms/au/au.service';
import { DocumentViewerComponent } from '../support/document-viewer/document-viewer.component';
import { DocViewerConfig } from '../support/models/doc-viewer-config.model';

// NOTE: when dealing with server side rendering as we are, check for window before doing things with it.
// If you're not doing server side rendering, then you don't need this check and can just assign straight to window.
if (typeof window !== 'undefined') {
  window.proj4 = window.proj4 || proj4;
}

export default proj4;

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent {
  @ViewChild('datePicker') datePicker: any; // assuming your date picker reference variable is datePicker
  selectedDate: Date;
  showCalendar: boolean = false;
  dateCustomClasses: any; // Add your custom classes here
  oneQmsOrgUsersDetails: any;

  hideCalendar() {
    // Delay hiding calendar to ensure click event on calendar can trigger
    setTimeout(() => {
      this.showCalendar = false;
    }, 200);
  }
  grouphDataList: any = [];
  ecGrouphDataList: any = [];
  dmsGrouphDataList: any = [];
  trainingCountList: any = [];
  activityGroupIntervalList: any = [];
  userDetails: any = {};
  userGroupList: any = {};
  groupCount: any;
  categoryList: any = {};
  categoryCount: any;
  documentsList: any = {};
  documentsCount: any;
  isProcessing: boolean = false;
  showCharts: boolean = false;

  chartOptionsForDMS: any;
  chartOptionsForAxis: any;
  actionList: any = [];
  riskList: any = [];
  homeDMSStatusList: any = [];
  homeDMSNStatusList: any = [];

  showReportFlagValue: any;
  PageName: any;
  searchValue: any;
  error = '';
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  dropDownForModules: any;
  popupTitle: any;
  groupValueDropdown: any = [];
  groupdataList: any = [];
  stageAndStatus: any = [];
  dropDownForDateRange: any = [];
  dropDownForInterval: any = [];
  stageValueDropdown: any = [];
  dateRangeValueDropdown: any = [];
  statusValueDropdown: any = [];
  intervalValueDropdown: any = [];
  selectedStatusValue: any = [];
  selectedDateRangeValue: any = [];
  selectedIntervalValue: any = []
  selectedStageValue: any = [];
  selectedGroupValue: any = [];
  fromDate: any;
  toDate: any;
  showSpecificInterval: boolean = false;
  titleName = '';
  clickedType = "";
  clickedVal = "";
  clickedStageStatusVal = "";

  chartOptionsForGroup: any;
  chartOptionsForTrainings: any;


  chartOptionsForStatus: any;
  chartOptionsForBa: any;
  chartOptionsForDepartment: any;
  chartOptionsForTaskType: any;
  chartOptionsForActivity: any;
  chartOptionsForActivityInprogressVSTotal: any;
  chartOptionsForEC: any;
  chartOptionsForExtention: any;
  chartOptionsForAction: any;
  chartOptionsForStagesStatus: any;

  chartOptionsForStagesZoom: any;
  chartOptionsForStatusZoom: any;
  chartOptionsForBaZoom: any;
  chartOptionsForDepartmentZoom: any;
  chartOptionsForTaskTypeZoom: any;
  chartOptionsForActivityZoom: any;
  chartOptionsForActivityInprogressVSTotalZoom: any;
  chartOptionsForECZoom: any;
  chartOptionsForExtentionZoom: any;
  chartOptionsForActionZoom: any;
  chartOptionsForStagesStatusZoom: any;
  chartOptionsForEcGroup: any;
  chartOptionsAction: any;
  chartOptionsRisk: any;
  chartOptionsForDmsGroup: any;
  chartOptionsForDMSStatus: any;
  chartOptionsDMSNstatus: any;
  chartOptionsForGroupZoom: any;
  chartOptionsForTrainingsZoom: any;
  chartOptionsForAxisZoom: any;
  chartOptionsForDmsGroupZoom: any;
  chartOptionsForEcGroupZoom: any;
  chartOptionsDMSNstatusZoom: any;
  chartOptionsForDMSStatusZoom: any;
  chartOptionsActionZoom: any;
  chartOptionsRiskZoom: any;

  userImage: any = null;
  badgeName: any = "";
  myTaskCount: any = 0;
  countMyTr: any = 0;
  trainingProfileTitle: any;
  orgDetails: any;
  managerCount: any = 0;

  dayStartHour: number = 8;
  dayEndHour: number = 18;
  myTagsList: any = [];
  @ViewChild('globalChart') globalChart: any;
  chartConstructor = 'mapChart';
  mapData: any;
  chartInstance: Highcharts.Chart | any;
  chartOptions: Highcharts.Options;
  chartOptions1: Highcharts.Options;
  //  public let fetchRes:any;
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  getChartInstance(e: Highcharts.Chart) {
    this.chartInstance = e;
    this.chartInstance.reflow();
  }
  Highcharts: typeof Highcharts = Highcharts;

  countries: any = [];
  allCountries: any = [];
  selectedDate1: Date;
  messageCount: any = 0;
  teamMembersList: any = [];
  organizationPrivelegesData: any = {};
  dataSource: any;
  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    private elem: ElementRef, public message: messageService, public qmsservice: qmsService, private datePipe: DatePipe, private activatedRoute: ActivatedRoute,
    public paginationService: PaginationService, public SVC: messageService, private readonly geolocation$: GeolocationService,
    public auService: AuService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.message.breadcrumbData.firstLevel = "Home";
    this.selectedDate = new Date();
    this.message.showComplaintSwitch = true;
    this.message.showIncidentSwitch = true;
    console.log("ORG ID → ", this.message.getOrgId());
    console.log("USER ID → ", this.message.getUserId());
  }

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;

  @ViewChild('eventDetailPopup', { static: true }) eventDetailPopup: TemplateRef<any>;
  visibleEventDetailPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('bulkUploadPopup', { static: true }) bulkUploadPopup: TemplateRef<any>;
  visibleBulkUploadPopup: MatDialogRef<TemplateRef<any>>;

  reportPopupConfig = {
    width: '80%',
    height: '600px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  bulkUploadPopupConfig = {
    width: '100%',
    height: '600px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  eventDetailPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  @ViewChild('bulkDownloadPopup', { static: true }) bulkDownloadPopup: TemplateRef<any>;
  visibleBulkDownloadPopup: MatDialogRef<TemplateRef<any>>;

  bulkDownloadPopupConfig = {
    width: '100%',
    minHeight: '60vh',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#05004E',
    '#839EFF',
    '#00A6A9',
    '#0081A5'
  ];
  //colorList=['#F9F871','#6B7887','#6B7887'];
  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];;
    }

  }

  onGroupValueSelect(item: any) {
    this.handleDropDownValidation('groupNameAlert', this.selectedGroupValue)
  }
  onGroupValueDeSelect(item: any) {
    this.handleDropDownValidation('groupNameAlert', this.selectedGroupValue)
  }
  onStageValueSelect(item: any) {
    for (let i = 0; i < this.stageAndStatus.length; i++) {
      if (this.stageAndStatus[i].stageName == item.valueExp) {
        this.statusValueDropdown = [];
        const statusArray = this.stageAndStatus[i].listOfStatus.split(',').map((status: string) => status.trim());
        this.statusValueDropdown = this.statusValueDropdown.concat(statusArray.filter((status: any) => !this.statusValueDropdown.includes(status)));

      }
    }
  }
  onStatusValueSelect(item: any) {
    // this.selectedStatusValue = item.valueExp;
  }

  onDateRangeValueSelect(item: any) {
    // this.selectedDateRangeValue = item.valueExp;
  }
  onIntervalValueSelect(item: any) {
    // this.selectedIntervalValue = item.valueExp;
  }

  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (let i = 0; i < this.groupdataList.length; i++) {
      this.groupValueDropdown = this.groupValueDropdown.concat({
        valueExp: this.groupdataList[i].groupId,
        displayExp: this.groupdataList[i].groupName
      });
    }
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    for (let i = 0; i < this.dropDownForDateRange.length; i++) {
      this.dateRangeValueDropdown = this.dateRangeValueDropdown.concat({
        valueExp: this.dropDownForDateRange[i].codelistCode,
        displayExp: this.dropDownForDateRange[i].codelistName
      });
    }
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    for (let i = 0; i < this.dropDownForInterval.length; i++) {
      this.intervalValueDropdown = this.intervalValueDropdown.concat({
        valueExp: this.dropDownForInterval[i].codelistCode,
        displayExp: this.dropDownForInterval[i].codelistName
      });
    }
  }

  selectBoxeForStageValue() {
    this.stageValueDropdown = [];
    for (let i = 0; i < this.stageAndStatus.length; i++) {
      this.stageValueDropdown = this.stageValueDropdown.concat({
        valueExp: this.stageAndStatus[i].stageName,
        displayExp: this.stageAndStatus[i].stageName
      });
    }
    this.stageAndStatus.forEach((item: { listOfStatus: string; }) => {
      const statusArray = item.listOfStatus.split(',').map(status => status.trim());
      this.statusValueDropdown = this.statusValueDropdown.concat(statusArray.filter(status => !this.statusValueDropdown.includes(status)));
    });
  }

  specificIntervalVal: boolean = false;
  specificIntervalFun(e: any) {
    if (e.checked == true) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      this.fromDate = null;
      this.toDate = null;
      this.selectedDateRangeValue = [{
        valueExp: 'CREATED',
        displayExp: 'Created Date'
      }];
      this.selectedIntervalValue = [{
        valueExp: 'MONTH',
        displayExp: 'MONTH'
      }];
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }


  isCalendarVisible: boolean = true;

  dateFormat: any = this.appService.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    visible: true
  };


  stageList: any = [];
  statusList: any = [];
  baList: any = [];
  departmentList: any = [];
  taskTypeList: any = [];
  activityReportList: any = [];
  inprogressVSTotalList: any = [];
  stageStatusList: any = [];
  tableReportDataList: any = [];
  tempTableReportDataList: any = [];
  extensionTableReportDataList: any = [];
  ecTableReportDataList: any = [];
  actionTableReportDataList: any = [];
  ecList: any = [];
  extensionList: any = [];

  resetFunction() {
    this.specificIntervalVal = false;
    this.fromDate = null;
    this.toDate = null;
    this.selectedStageValue = [];
    this.selectedStatusValue = [];
    this.selectedGroupValue = [];
    this.showCharts = false;

  }

  getDataPointsForGroups() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.grouphDataList.map((gr: { cnt: any; groupName: any; }, index: any) => ({
      y: gr.cnt,
      indexLabel: `${gr.groupName}:${gr.cnt}`,
      color: this.colorMethod(gr.groupName, index)
    }));
    return dataPoints;
  }
  getDataPointsForEcGroups() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.ecGrouphDataList.map((gr: { cnt: any; groupName: any; }, index: any) => ({
      y: gr.cnt,
      indexLabel: `${gr.groupName}:${gr.cnt}`,
      color: this.colorMethod(gr.groupName, index)
    }));
    return dataPoints;
  }
  getDataPointsForDmsGroups() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.dmsGrouphDataList.map((gr: { count: any; documentTypeName: any; }, index: any) => ({
      y: gr.count,
      indexLabel: `${gr.documentTypeName}:${gr.count}`,
      color: this.colorMethod(gr.documentTypeName, index)
    }));
    return dataPoints;
  }



  getDataPointsForStatus() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.statusList.map((statu: { count: any; status: any; }) => ({
      label: `${statu.status}`,
      y: statu.count

    }));
    return dataPoints;
  }
  getDataPointsForStageStatus() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.stageStatusList.map((statu: { count: any; status: any; }) => ({
      y: statu.count,
      indexLabel: `${statu.status} : ${statu.count}`
    }));
    return dataPoints;
  }
  getDataPointsForBa() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.baList.map((ba: { cnt: any; baValue: any; }) => ({
      label: `${ba.baValue}`,
      y: ba.cnt

    }));
    return dataPoints;
  }

  getDataPointsForDepartment() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.departmentList.map((dep: { count: any; deptCode: any; }) => ({
      label: `${dep.deptCode}`,
      y: dep.count
    }));
    return dataPoints;
  }

  getDataPointsForTaskType() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.trainingCountList.map((tc: { trainingCount: any; levelStatus: any; }, index: any) => ({
      y: tc.trainingCount,
      indexLabel: `${tc.levelStatus}: ${tc.trainingCount}`,
      color: this.colorMethod(tc.levelStatus, index)
    }));
    return dataPoints;
  }
  getDataPointsForDMSStatus() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.homeDMSStatusList.map((tc: { count: any; status: any; }, index: any) => ({
      y: tc.count,
      indexLabel: `${tc.status}: ${tc.count}`,
      color: this.colorMethod(tc.status, index)
    }));
    return dataPoints;
  }
  getDataPointsForDMSNStatus() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.homeDMSNStatusList.map((tc: { count: any; status: any; }, index: any) => ({
      y: tc.count,
      indexLabel: `${tc.status}: ${tc.count}`,
      color: this.colorMethod(tc.status, index)
    }));
    return dataPoints;
  }
  getDataPointsForActivityReport() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.activityReportList.map((item: { axisValue: any; count: any; }) => ({
      label: item.axisValue,
      y: item.count
    }));
    return dataPoints;
  }


  dataPointsMultiLine() {
    const data = [];
    const groupedData = this.groupBy(this.activityGroupIntervalList, 'groupName');
    for (const groupName in groupedData) {
      if (groupedData.hasOwnProperty(groupName)) {

        const groupData = groupedData[groupName];
        const dataPoints = this.getDataPointsForGroupLine(groupData);
        data.push({
          type: "line",
          name: groupName,
          showInLegend: "true",
          // indexLabel:  "{y}",
          yValueFormatString: "#,###",
          dataPoints: dataPoints,

        });
      } else {

      }
    }
    return data;
  }
  getDataPointsForGroupLine(activityGroupIntervalList: any[]) {
    const aggregatedData: { [key: string]: number } = {};
    activityGroupIntervalList.forEach((ac: { cnt: any; axisValue: any; }) => {
      const axisValue = ac.axisValue.toString();
      if (aggregatedData.hasOwnProperty(axisValue)) {
        aggregatedData[axisValue] += ac.cnt;
      } else {
        aggregatedData[axisValue] = ac.cnt;
      }
    });
    const dataPoints = Object.keys(aggregatedData).map(axisValue => ({
      label: axisValue,
      y: aggregatedData[axisValue]
    }));
    return dataPoints;
  }
  getDataPointsAction() {
    const data = [];
    const groupedData = this.groupBy(this.actionList, 'groupName');
    for (const groupName in groupedData) {
      if (groupedData.hasOwnProperty(groupName)) {
        const groupData = groupedData[groupName];
        const dataPoints = this.getDataPointsForGroup(groupData);
        data.push({
          type: "stackedBar",
          name: groupName,
          showInLegend: "true",
          // indexLabel:  "{y}",
          yValueFormatString: "#,###",
          dataPoints: dataPoints
        });
      }
    }
    return data;
  }

  getDataPointsForGroup(actionList: any[]) {
    const aggregatedData: { [key: string]: number } = {};
    actionList.forEach((ac: { cnt: any; status: any; }) => {
      const status = ac.status.toString();
      if (aggregatedData.hasOwnProperty(status)) {
        aggregatedData[status] += ac.cnt;
      } else {
        aggregatedData[status] = ac.cnt;
      }
    });
    const dataPoints = Object.keys(aggregatedData).map(status => ({
      label: status,
      y: aggregatedData[status]
    }));
    return dataPoints;
  }
  groupBy(array: any[], key: string) {
    return array.reduce((acc, obj) => {
      const property = obj[key];
      acc[property] = acc[property] || [];
      acc[property].push(obj);
      return acc;
    }, {});
  }



  dataPointsRisk() {

    const data = [];
    const groupedData = this.groupBy(this.riskList, 'groupName');
    for (const groupName in groupedData) {
      if (groupedData.hasOwnProperty(groupName)) {
        const groupData = groupedData[groupName];
        const dataPoints = this.getDataPointsForGroupRiskType(groupData);
        data.push({
          type: "stackedBar",
          name: groupName,
          showInLegend: "true",
          yValueFormatString: "#,###",
          dataPoints: dataPoints
        });
      }
    }
    return data;


  }

  getDataPointsForGroupRiskType(riskList: any[]) {
    const aggregatedData: { [key: string]: number } = {};
    riskList.forEach((ac: { cnt: any; finalRiskStatus: any; }) => {
      const finalRiskStatus = ac.finalRiskStatus.toString();
      if (aggregatedData.hasOwnProperty(finalRiskStatus)) {
        aggregatedData[finalRiskStatus] += ac.cnt;
      } else {
        aggregatedData[finalRiskStatus] = ac.cnt;
      }
    });
    const dataPoints = Object.keys(aggregatedData).map(finalRiskStatus => ({
      label: finalRiskStatus,
      y: aggregatedData[finalRiskStatus]
    }));
    return dataPoints;
  }
  dataPointsAvgTimeInprogress() {
    //let k=4;
    // Transform your data into CanvasJS dataPoints format
    const dataPointsAvgTimeInprogress = this.activityReportList.map((item: { axisValue: any; avgTimeTakenAtInprogress: any; }) => ({
      label: item.axisValue,
      //y:k++
      y: item.avgTimeTakenAtInprogress
    }));

    return dataPointsAvgTimeInprogress;
  }




  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];

  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    this.pagedItems = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }

  // setPage2(page: number, targetpage: number) {
  //   if (page < 1 || page > this.pager.totalPages) {
  //     return;
  //   }
  //   if (Number.isNaN(page)) {
  //     page = 1;
  //   }

  //   this.pager = this.paginationService.getPager(this.extensionTableReportDataList.length, page, this.perPage, targetpage);
  //   this.pagedItems1 = this.extensionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  // }

  // paginationCall2(value: number) {
  //   this.perPage = value;
  //   this.setPage2(this.pager.currentPage, 0);
  // }

  setPage3(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.ecTableReportDataList.length, page, this.perPage, targetpage);
    this.pagedItems2 = this.ecTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall3(value: number) {
    this.perPage = value;
    this.setPage3(this.pager.currentPage, 0);
  }

  setPage4(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.actionTableReportDataList.length, page, this.perPage, targetpage);
    this.pagedItems3 = this.actionTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall4(value: number) {
    this.perPage = value;
    this.setPage4(this.pager.currentPage, 0);
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field.style.color = selectedItems.length === 0 && field ? 'red' : '';
  }

  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
  }


  clickedChartVal: any;
  homeChartDoubleClick(val: any) {
    this.createHomeChartZoom(val);
    this.clickedChartVal = val;
    this.visibleReportPopupForZoom = this.dialog.open(this.reportPopupForZoom, this.reportPopupConfig);

  }
  createHomeChartZoom(val: any) {
    if (val == 1) {
      this.chartOptionsForGroupZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "Groups",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{groupName}:{cnt}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForGroups(),
        }]
      };
    }
    if (val = 2) {
      this.chartOptionsForTrainingsZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "My Trainings",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "doughnut",
          indexLabel: "{levelStatus}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForTaskType(),
          //click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }],
      }
    }
    if (val = 3) {
      this.chartOptionsForAxisZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "Group Intervals",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        // to remove horizontal lines
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        toolTip: {
          shared: true
        },
        data: this.dataPointsMultiLine()
      }

    }
    if (val = 4) {
      this.chartOptionsForDmsGroupZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
        },
        title: {
          text: "DMS Document Type",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{documentTypeName}:{count}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForDmsGroups(),
        }]

      };
    }
    if (val = 5) {

      this.chartOptionsForEcGroupZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "EC",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{groupName}:{cnt}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForEcGroups(),
          //  click: this.handleStageChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }]

      };
    }
    if (val = 6) {
      this.chartOptionsDMSNstatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "DMS Normal Status",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "doughnut",
          indexLabel: "{status}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForDMSNStatus(),
          //click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }
    if (val = 7) {
      this.chartOptionsForDMSStatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "DMS Status",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "doughnut",
          indexLabel: "{status}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForDMSStatus(),
          //click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }
    if (val = 8) {
      this.chartOptionsActionZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        dataPointMaxWidth: 10,
        title: {
          text: "Action Status",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          gridThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        axisY: {
          tickLength: 0,
          gridThickness: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        toolTip: {
          shared: true
        },
        data: this.getDataPointsAction()
      };
    }
    if (val = 9) {
      this.chartOptionsRiskZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: "Risk Status",
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          gridThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        axisY: {
          tickLength: 0,
          gridThickness: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        dataPointMaxWidth: 10,
        toolTip: {
          shared: true
        },
        data: this.dataPointsRisk()
      }
    }
  }





  trainingChartMethod() {

    this.chartOptionsForGroup = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "Groups",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{groupName}:{cnt}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForGroups(),
      }]

    };



    this.chartOptionsForEcGroup = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "EC",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{groupName}:{cnt}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForEcGroups(),
        //  click: this.handleStageChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }]

    };

    this.chartOptionsForDmsGroup = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "DMS Document Type",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{documentTypeName}:{count}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForDmsGroups(),
      }]

    };


    this.chartOptionsForTrainings = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "My Trainings",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "doughnut",
        indexLabel: "{levelStatus}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForTaskType(),
        //click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }],
    };

    this.chartOptionsForDMS = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "DMS",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "doughnut",
        indexLabel: "{levelStatus}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForTaskType(),
        //click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }]
    };

    this.chartOptionsForDMSStatus = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "DMS Status",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "doughnut",
        indexLabel: "{status}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForDMSStatus(),
        //click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }]
    };

    this.chartOptionsDMSNstatus = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "DMS Normal Status",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "doughnut",
        indexLabel: "{status}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForDMSNStatus(),
        //click: this.handleTaskTypeChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }]
    };


    this.chartOptionsForAxis = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "Group Intervals",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      // to remove horizontal lines
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      toolTip: {
        shared: true
      },
      data: this.dataPointsMultiLine()
    };

    this.chartOptionsAction = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      dataPointMaxWidth: 10,
      title: {
        text: "Action Status",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        gridThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisY: {
        tickLength: 0,
        gridThickness: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      toolTip: {
        shared: true
      },
      data: this.getDataPointsAction()
    };

    this.chartOptionsRisk = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "Risk Status",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        gridThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisY: {
        tickLength: 0,
        gridThickness: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      dataPointMaxWidth: 10,
      toolTip: {
        shared: true
      },
      data: this.dataPointsRisk()
    };
    this.showCharts = true;


  }





  applyStyle(value: any) {
    return {
      "background-color": value
    };
  }
  getBadgeImageUrl(badgeName: string): string {
    let hyperRemoveData = badgeName.replace(/-/g, '');
    let badge = hyperRemoveData.replace(/\s/g, '');
    let newBadge = badge[0].toUpperCase() + badge.substr(1).toLowerCase();
    let imagePath = '../../assets/img/' + newBadge + '.png';
    return imagePath;
  }
  openInformationPopup(popupData: any, event: any) {
    // event.preventDefault();
    // this.trainingProfileTitle = popupData;
    // this.visibleTrainingProfilePopup = this.dialog.open(this.trainingProfilepopup,this.trainingProfilePopupConfig);
    // if(popupData == 'Documents'){
    //   this.collectionSize=this.userDocuments.length;
    //     this.pager.totalPages=undefined;
    //     this.setPage2(1,0);
    // }
  }
  oneQmsUserImagesDetails: any = {};
  oneQmsOrgImagesDetails: any = {};
  totalCount: any = 0;
  activeNode: any = "";
  showRaiseIncident: boolean = false;
  showRaiseComplaint: boolean = false;
  isShowBulkUpload = false;
  isShowBulkDownload = false;
  listOfDmsIssuanceTypes: any = [];
  warningMsg: any;

  private getUserProfileImage() {
    this.qmsservice.getOneQmsOrgUsersDetails = JSON.parse(sessionStorage.getItem('oneQmsOrgUsersDetails') || '{}');
    if (this.qmsservice.getOneQmsOrgUsersDetails && this.qmsservice.getOneQmsOrgUsersDetails.userImage) {
      this.userImage = "data:image/*;base64," + this.qmsservice.getOneQmsOrgUsersDetails.userImage;
    } else {
      this.userImage = null;
    }
  }
  organizationPrivelegesDetails: any;
  ngOnInit() {
    this.getLocation();
    this.appService.getOneQmsOrganizationPrivileges().subscribe((data: any) => {
      data.docs = data.docs == "Y";
      this.organizationPrivelegesDetails = data;
      this.isProcessing = false;
    })
    this.isProcessing = true;
    this.appService.getMyTags().subscribe((data: any) => {
      this.isProcessing = false;
      this.myTagsList = data;
    })
    // this.isProcessing = true;
    this.message.isMyTaskFromDashboard = true;
    this.oneQmsUserImagesDetails = JSON.parse(sessionStorage.getItem('oneQmsOrgUsersDetails') || '{}');
    this.orgDetails = JSON.parse(sessionStorage.getItem('orgDetails') || '{}');
    this.appService.getPrivForHomePage().subscribe((data: any) => {
      if (data != 0) {
        this.isShowBulkUpload = true;
      }
    })
    this.appService.getDownloadPrivForHomePage().subscribe((data: any) => {
      if (data != 0) {
        this.isShowBulkDownload = true;
      }
    })
    this.appService.getCodeListsByGroup("DOCUMENT_ISSUANCE_TYPE").subscribe((data: any) => {
      this.listOfDmsIssuanceTypes = data;

    })
    this.appService.getOneQmsUserDetails().subscribe((response: any) => {
      this.oneQmsOrgUsersDetails = response;
      this.qmsservice.getOneQmsOrgUsersDetails = response;
      sessionStorage.setItem('oneQmsOrgUsersDetails', JSON.stringify(response));
      this.getUserProfileImage();
    })
    this.showCalendar = true;
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'))
    }, 1)
    this.orgDetails = JSON.parse(sessionStorage.getItem("orgDetails") || '[]');
    this.allCountries = JSON.parse(sessionStorage.getItem("dropDownForCountry") || '[]');
    if (this.orgDetails.orgCountries) {
      const countries = this.orgDetails.orgCountries.split(",");

      for (let i = 0; i < countries.length; i++) {
        const country = this.allCountries?.find((x: any) => x.codelistCode == countries[i]);
        this.countries.push({ code3: countries[i], name: country.codelistName });
      }
    }
    this.createMapChart1();
    this.checkUserPriv();
    this.loggedUserId = this.message.getUserId();

    this.appService.userPrivsDetails(this.loggedUserId).subscribe((data: any) => {
      this.organizationPrivelegesData = data;
      if (data.isTrainingUser == "Y") {
        this.callTrnMethod();
      }
      if (data.isDocumentUser == "Y") {
        this.callDocMethod();
      }
      if (data.isQualityUser == "Y") {
        this.callQualityMethod();
      }
      // this.organizationPrivelegesDetails = data;
      // this.organizationPrivelegesData = this.organizationPrivelegesDetails;
      // this.organizationPrivelegesData.trn = this.organizationPrivelegesData.trn == "Y";
      // this.organizationPrivelegesData.docs = this.organizationPrivelegesData.docs == "Y";
      // this.organizationPrivelegesData.formsAndLogs = this.organizationPrivelegesData.formsAndLogs == "Y";
      // this.quality = this.organizationPrivelegesData.cr || this.organizationPrivelegesData.capa || this.organizationPrivelegesData.dv || this.organizationPrivelegesData.au || this.organizationPrivelegesData.in || this.organizationPrivelegesData.qi || this.organizationPrivelegesData.cc;
      // this.isProcessing = false;
    })
    this.appService.getUserDetailsForTrainingDashboard().subscribe((data: any) => {
      this.userDetails = data[0];
    })

    this.appService.managerCount().subscribe((data: any) => {
      this.teamMembersList = data;
      if (data.length > 0) {
        this.managerCount = data.length;
      }
    })
    const promises = [
      this.appService.getReportDMSNStatusRepHomePage(),
      this.appService.getReportDMSCountHomePage(),
      this.appService.getReportEcStatusCountHomePage(),
      this.appService.getReportGroupsHomePage(),
      this.appService.getTrainingsRepCount(),
      this.appService.getGroupsForTrainingDash(),
      this.appService.getCategoriesList(),
      this.appService.getDocumentsForTrainingDash(),
      this.appService.getReportGroupIntervals(),
      this.appService.getReportGroupAction(),
      this.appService.getReportGroupRisk(),
      this.appService.getReportDMSStatusRepHomePage(),
      this.appService.getRootNodes("All")
    ].map(promise => promise.toPromise()); // Convert each observable to a promise

    // Use Promise.all to wait for all promises to resolve
    Promise.all(promises)
      .then(([dmsnStatus, dmsRepCount, ecChartData, typdropDownForDateRangeData, trainingCountList, userGroupList, categoryList, documentsList, activityGroupIntervalList, actionList, riskList, homeDMSStatus, myTaskCount]) => {
        this.homeDMSNStatusList = dmsnStatus;
        this.dmsGrouphDataList = dmsRepCount;
        this.ecGrouphDataList = ecChartData;
        this.grouphDataList = typdropDownForDateRangeData;
        this.trainingCountList = trainingCountList;
        this.userGroupList = userGroupList;
        this.groupCount = this.userGroupList.length;
        this.categoryList = categoryList;
        this.categoryCount = this.categoryList.length;
        this.documentsList = documentsList;
        this.documentsCount = this.documentsList.length;
        this.activityGroupIntervalList = activityGroupIntervalList;
        this.actionList = actionList;
        this.riskList = riskList;
        this.homeDMSStatusList = homeDMSStatus;
        this.myTaskCount = myTaskCount;
        for (let i = 0; i < this.trainingCountList.length; i++) {
          this.countMyTr = this.countMyTr + this.trainingCountList[i].trainingCount;


        }
        this.isProcessing = false;
      },
        error => {
          console.error('Error in forkJoinObservable:', error);
        });

    this.appService.getOneQmsReceivedTopics().subscribe((response: any) => {
      const topicsData = response;
      this.messageCount = 0;
      for (const topic of topicsData) {
        topic.readAlready == "N" && this.messageCount++;
      }
      this.messageCount = this.messageCount > 99 ? "99+" : this.messageCount;
    })
    this.appService.getBadgeRangeForTmsUser()
      .subscribe((data: any) => {
        if (data.length > 0) {
          this.badgeName = data[0];
        }
      });
    this.appService.getAllOrgReportImages().subscribe((response1: any) => {
      this.oneQmsOrgImagesDetails = response1;
    })

  }

  privData: any
  checkUserPriv() {
    this.appService.checkRaiseInRaiseCcUserPriv().subscribe((result: any) => {
      this.privData = result;
      this.showRaiseIncident = this.privData[0].raiseIn == 'Y';
      this.showRaiseComplaint = this.privData[0].raiseCc == 'Y';
    })
  }
  pos: any = {
    lat: 0,
    lng: 0
  };
  withLocalation = false;
  getLocation() {
    this.geolocation$.subscribe((position) => {
      this.withLocalation = true;
      this.pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      this.createMapChart();
    }, (error: any) => {
      this.withLocalation = false;
      this.createMapChart1();
    })
  }
  openCalView(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.router.navigate(['/dashboard/calendarPage']);
  }

  popupList: any = [];
  setPage2(page: number, targetpage: number, list: any) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(list.length, page, this.perPage, targetpage);
    this.pagedItems = list.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall2(value: number, list: any) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0, list);
  }

  cancelViewdataPopup() {
    this.visibleViewDataPopup.close();
  }


  labelsForTrainings = ['Completed Trainings', 'Not completed Trainings'];
  labelsForDocs = ['Assigned Documents', 'Not Assigned Documents'];
  labelsForQuality = ['Assigned Modules', 'Not Assigned Modules'];
  labelsForGroups = ['Assigned Groups', 'Not Assigned Groups'];
  createChart(firstRound: any, secondRound: any) {
    this.chart = new Chart("MyChartForTraining", {
      type: 'doughnut', //this denotes tha type of chart

      data: {
        labels: ["Assigned", "Not Assigned"],
        datasets: [{
          label: 'Groups',
          data: firstRound,
          backgroundColor: [
            "#005C8A",
            "#DEEBFE",

          ],
        }, {
          label: 'Trainings',
          data: secondRound,
          backgroundColor: [
            "#F8D302",
            "#DEEBFE",

          ],
        }],
      },

      options: {

        responsive: true,
        cutout: '65%',
        plugins: {
          tooltip: {
            enabled: true,
            callbacks: {
              label: (data: any) => {
                if (data.dataset.label == "Groups") {
                  return data.dataset.data[data.dataIndex] + " - Groups";
                } else {
                  return data.dataset.data[data.dataIndex] + " - Trainings";
                }


              }
            }
          },
          legend: {
            display: false
          }
        },

        elements: {

        },
        onClick: (e, activeEls) => {
          this.isProcessing = true;
          this.appService.getHomePageDataForTrainingDetail()
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.popupList = data;
              this.collectionSize = data.length;
              this.pager.totalPages = undefined;
              this.setPage2(1, 0, data);
              this.popupVal = "Trainings";
              this.ColumnList = [{ "name": "Group", "width": "160px" }, { "name": "Training Count", "width": "140px" },
              { "name": "Training Names", "width": "300px" }];
              this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
            }, (error: any) => {
              this.isProcessing = false;
            })
        }
      }
    });
  }
  public chart: any;
  createChartDocument(firstRound: any, secondRound: any) {
    this.chart = new Chart("MyChartForDocument", {
      type: 'doughnut', //this denotes tha type of chart

      data: {
        labels: ["Assigned", "Not Assigned"],
        datasets: [{
          label: 'Groups',
          data: firstRound,
          backgroundColor: [
            "#005C8A",
            "#DEEBFE",

          ],
        }, {
          label: 'Documents',
          data: secondRound,
          backgroundColor: [
            "#F8D302",
            "#DEEBFE",

          ],
        }],
      },

      options: {

        responsive: true,
        cutout: '65%',
        plugins: {
          tooltip: {
            enabled: true,
            callbacks: {
              label: (data: any) => {
                if (data.dataset.label == "Groups") {
                  return data.dataset.data[data.dataIndex] + "- Groups";
                } else {
                  return data.dataset.data[data.dataIndex] + " - Folders";
                }


              }
            }
          },
          legend: {
            display: false
          }
        },

        elements: {

        },
        onClick: (e, activeEls) => {
          this.isProcessing = true;
          this.appService.getHomePageDataForDocumentDetail()
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.popupList = data;
              this.collectionSize = data.length;
              this.pager.totalPages = undefined;
              this.setPage2(1, 0, data);
              this.popupVal = "Documents";
              this.ColumnList = [{ "name": "Group", "width": "160px" }, { "name": "Folder Count", "width": "140px" },
              { "name": "Folder Names", "width": "200px" }, { "name": "User", "width": "160px" }, { "name": "Roles", "width": "160px" }];
              this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
            })
        }
      }
    });
  }

  createChartForQuality(firstRound: any, secondRound: any) {
    this.chart = new Chart("MyChartForQuality", {
      type: 'doughnut', //this denotes tha type of chart

      data: {
        labels: ["Assigned", "Not Assigned"],
        datasets: [{
          label: 'Groups',
          data: firstRound,
          backgroundColor: [
            "#005C8A",
            "#DEEBFE",

          ],
        }, {
          label: 'Quality',
          data: secondRound,
          backgroundColor: [
            "#F8D302",
            "#DEEBFE",

          ],
        }],
      },

      options: {

        responsive: true,
        cutout: '65%',
        plugins: {
          tooltip: {
            enabled: true,
            callbacks: {
              label: (data: any) => {
                if (data.dataset.label == "Groups") {
                  return data.dataset.data[data.dataIndex] + " - Groups";
                } else {
                  return data.dataset.data[data.dataIndex] + " - Modules";
                }


              }
            }
          },
          legend: {
            display: false
          }
        },

        elements: {

        },
        onClick: (e, activeEls) => {
          this.isProcessing = true;
          this.appService.getHomePageDataForQualityDetail()
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.popupList = data;
              this.collectionSize = data.length;
              this.pager.totalPages = undefined;
              this.setPage2(1, 0, data);
              this.popupVal = "Quality";
              this.ColumnList = [{ "name": "Group", "width": "160px" }, { "name": "Module Count", "width": "140px" },
              { "name": "Modules", "width": "200px" }];
              this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
            })
        }
      }
    });
  }


  visibleViewDataPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('viewDatapopup', { static: true }) viewDatapopup: TemplateRef<any>;

  viewDataPopupConfig = {
    width: '100%',
    minHeight: '700px',
    maxHeight: '90vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleNotificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('notificationPopup', { static: true }) notificationPopup: TemplateRef<any>;

  notificationPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  documentDataForDocBulkUpload: any;
  documentAddOptionForFolder: any;
  dropDownFordocumentTypeList: any = [];
  reportList: any = [];
  isAddDocForBulkUpload = false;
  isShowAddPanel = false;
  popupVal: any;
  eventsList: any = [];
  @ViewChild(RaiseInComponent) raiseInComponent: RaiseInComponent;
  @ViewChild(RaiseCcComponent) raiseCcComponent: RaiseCcComponent;
  openPopup(val: any) {
    if (val == "mytask") {
      this.appService.setRouteOfMyTask("All");
      this.router.navigate(['/dashboard/MyTasks']);
    } else if (val == "user") {
      this.popupVal = "Team Users";
      this.collectionSize = this.teamMembersList.length;
      this.pager.totalPages = undefined;
      this.setPage2(1, 0, this.teamMembersList);
      this.ColumnList = [{ "name": "User Name", "width": "160px" }, { "name": "First Name", "width": "120px" },
      { "name": "Last Name", "width": "120px" }, { "name": "Email", "width": "140px" }, { "name": "Designation", "width": "140px" },
      { "name": "Department", "width": "140px" }]
      this.popupList = this.teamMembersList;
      this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
    } else if (val == "document") {
      this.popupVal = "Document";
      this.collectionSize = this.documentsList.length;
      this.pager.totalPages = undefined;
      this.setPage2(1, 0, this.documentsList);
      this.ColumnList = [{ "name": "Document No.", "width": "160px" }, { "name": "Version", "width": "120px" },
      { "name": "Document Name", "width": "180px" }, { "name": "Status", "width": "140px" }, { "name": "Type", "width": "140px" }]
      this.popupList = this.documentsList;
      this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
    } else if (val == "Saved Report") {
      this.popupVal = "Saved Report";
      this.isProcessing = true;
      this.appService.getSavedReportsForHomePage()
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.reportList = data;
          this.collectionSize = data.length;
          this.pager.totalPages = undefined;
          this.setPage2(1, 0, data);
          this.ColumnList = [{ "name": "Module", "width": "180px" }, { "name": "Report Name", "width": "200px" },
          { "name": "Report Status", "width": "180px" }, { "name": "Report", "width": "140px" }]
          this.popupList = data;
        })

      this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
    } else if (val == "Events") {

      this.visibleEventDetailPopup = this.dialog.open(this.eventDetailPopup, this.eventDetailPopupConfig);
    } else if (val == "Incident") {

      this.popupVal = "Incidents";
      this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);

    } else if (val == "Complaint") {
      this.popupVal = "Complaints";
      this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
    } else if (val == "Notifications") {
      this.qmsservice.activityId = null;
      this.visibleNotificationPopup = this.dialog.open(this.notificationPopup, this.notificationPopupConfig);


    } else if (val == "Bulk Upload") {
      this.documentDataForDocBulkUpload = {};
      this.documentAddOptionForFolder = null;
      this.visibleBulkUploadPopup = this.dialog.open(this.bulkUploadPopup, this.bulkUploadPopupConfig);
    } else if (val == "Bulk Download") {
      this.visibleBulkDownloadPopup = this.dialog.open(this.bulkDownloadPopup, this.bulkDownloadPopupConfig);
    } else if (val == "My Issuance History") {
      this.popupVal = val;
      this.SVC.isIssuanceFrom = "Home";
      this.visibleViewDataPopup = this.dialog.open(this.viewDatapopup, this.viewDataPopupConfig);
    } else {
      this.openTopicPopup();
    }
  }

  cancelEventsPopup() {
    this.visibleEventDetailPopup.close();
  }

  cancelNotificationPopup() {
    this.visibleNotificationPopup.close();
  }

  selectedTabIndex = 0;
  onTabChanged(event: any) {

  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true,
  };

  openTopicPopup() {
    this.SVC.communicatingFrom = 'Dashboard';
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
    this.isProcessing = true;
    this.appService.getOneQmsReceivedTopics().subscribe((response: any) => {
      const topicsData = response;
      this.messageCount = 0;
      for (const topic of topicsData) {
        topic.readAlready == "N" && this.messageCount++;
      }
      this.messageCount = this.messageCount > 99 ? "99+" : this.messageCount;
      this.isProcessing = false;
    })
  }

  ColumnList: any = [];
  addBadges(badgeName: any) {
    if (badgeName != "") {
      let hyperRemoveData = badgeName.replace(/-/g, '');
      let badge = hyperRemoveData.replace(/\s/g, '');
      let newBadge = badge[0].toUpperCase() + badge.substr(1).toLowerCase();
      let imagePath = '../../assets/img/' + newBadge + '.png';
      return {
        "background": "transparent url(" + imagePath + ") no-repeat center 25px",
        "margin-left": "-4%",
        "title": badgeName,
        "background-size": "50px 50px"
      };
    } else {
      return null;
    }
  }

  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;

  viewDoc(list: any) {
    this.isProcessing = true;

    try {
      // Determine content type from file extension
      const contentType = this.appService.getContentTypeByExtension(list.documentExtn);

      // Convert Base64 to Blob
      const blob = this.appService.base64ToBlob(list.document, contentType);

      // Prepare document object for WebViewer
      const doc = {
        body: blob,
        contentType: contentType,
        extn: list.documentExtn
      };

      this.docViewer = {
        blob,
        doc,
        docName: list.documentName,
        docExtension: list.documentExtn
      };

      // Open the viewer popup after slight delay
      setTimeout(() => {
        this.documentViewerComponent?.openPopUp();
      }, 0);

    } catch (err) {
      console.error('Error while decoding or preparing document:', err);
      alert('Failed to load document.');
    } finally {
      this.isProcessing = false;
    }
  }

  createMapChart() {
    this.chartOptions = {
      chart: {
        map: worldMap,
        proj4: proj4,
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false
      },
      accessibility: {
        enabled: false
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          alignTo: "spacingBox"
        }
      },

      series: [
        {
          type: "map",
          name: '',
          data: this.countries,
          joinBy: ['iso-a2', 'code3'],
          dataLabels: {
            enabled: false,
            format: "{point.name}"
          },
          states: {
            hover: {
              color: '#a4edba'
            }
          },


        },
        {
          // Specify points using lat/lon
          type: 'mappoint',
          name: '',
          marker: {
            radius: 5,
            fillColor: 'tomato',
          },
          data: [
            {
              name: '',
              lat: this.pos.lat,
              lon: this.pos.lng,
            },

          ],

        },
      ],

    };
  }

  createMapChart1() {
    this.chartOptions1 = {
      chart: {
        map: worldMap
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false
      },
      accessibility: {
        enabled: false
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          alignTo: "spacingBox"
        }
      },

      series: [
        {
          type: "map",
          name: '',
          data: this.countries,
          joinBy: ['iso-a2', 'code3'],
          dataLabels: {
            enabled: false,
            format: "{point.name}"
          },
          states: {
            hover: {
              color: '#a4edba'
            }
          },


        },

      ],

    };
  }

  callTrnMethod() {
    this.isProcessing = true;
    this.appService.getHomePageDataForTraining().subscribe((data: any) => {
      this.isProcessing = false;
      if (data != null) {
        let nongrp = 0;
        nongrp = data.grpTotalCnt - data.grpCnt;
        const firstRound = [data.grpCnt, nongrp];
        const secondRound = [data.completedCnt, data.trainingCnt];
        this.createChart(firstRound, secondRound);
      }

    })
  }

  callDocMethod() {
    this.isProcessing = true;
    this.appService.getHomePageDataForDocument().subscribe((data: any) => {
      this.isProcessing = false;
      if (data != null) {
        let nongrp = 0;
        nongrp = data.grpTotalCnt - data.grpCnt;
        let nonDoc = 0;
        nonDoc = data.folderTotalCnt - data.folderCnt;
        const firstRound = [data.grpCnt, nongrp];
        const secondRound = [data.folderCnt, nonDoc];
        this.createChartDocument(firstRound, secondRound);
      }

    })
  }

  callQualityMethod() {
    this.isProcessing = true;
    this.appService.getQualityGroupCount().subscribe((data: any) => {
      this.isProcessing = false;
      if (data != null) {
        let nongrp = 0;
        nongrp = data.grpTotalCnt - data.grpCnt;
        let nonDoc = 0;
        nonDoc = 7 - data.moduleCnt;
        const firstRound = [data.grpCnt, nongrp];
        const secondRound = [data.moduleCnt, nonDoc];
        this.createChartForQuality(firstRound, secondRound);
      }

    })
  }

  openLeftSideGridFunc(data: any) {
    this.activeNode = data;
    if (data.subModule == "My Trainings") {
      this.appService.myTraining = "mainPage"
      this.router.navigate(['/dashboard/trainingDashboard']);
    } else {
      this.router.navigate(['/dashboard/MyTasks']);

    }

  }



  cancelBulkUploadFunc() {
    this.visibleBulkUploadPopup.close();
  }

  changeInChild(event: any) {
    if (event) {
      this.visibleBulkUploadPopup.close();
    }
  }


  cancelBulkDownloadFunc() {
    this.visibleBulkDownloadPopup.close();
  }

  model = {
    documentData: {},
  };
  selectedAssociatedDoc: any = {};
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedAssociatedDoc = this.model.documentData;
  }

  model1 = {
    documentData: {
      isFrom: "",
      isAdd: true,
      documentId: null
    },
  };
  selectedDocList: any = [];
  changeInFolderStructureChildForDownload(data: any) {
    this.model1 = data;
    if (this.model1.documentData.isFrom != undefined && this.model1.documentData.isFrom != null) {
      if (this.model1.documentData.isFrom == "allDocuments") {
        this.selectedDocList = [];
      }
    }
    if (this.model1.documentData.documentId != null) {
      if (this.model1.documentData.isAdd) {
        this.selectedDocList.push(this.model1.documentData);
      } else {
        this.removeByAttr(this.selectedDocList, 'documentId', this.model1.documentData.documentId)
      }

    }
  }

  removeByAttr = function (arr: any[], attr: string | number, value: any) {
    let i = arr.length;
    while (i--) {
      if (arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value)) {

        arr.splice(i, 1);

      }
    }
    return arr;
  }

  popupDataTitle = {
    title: ''
  }

  @ViewChild('uploadImagesPopup1', { static: true }) uploadImagesPopup1: TemplateRef<any>;
  visibleUploadImagesPopup1: MatDialogRef<TemplateRef<any>>;

  uploadImagesPopupConfig = {
    width: '30%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  imageUploadFlag: any;
  uploadInputFiledValue: any;
  imageToUpload: File | any;
  profileImage: any;
  readURL(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.profileImage = reader.result;
      reader.readAsDataURL(file);
    }
  }
  openUserImageUploadPopup() {
    this.profileImage = null;
    this.imageToUpload = null;
    this.popupDataTitle.title = "User Profile";
    this.imageUploadFlag = "User";
    this.visibleUploadImagesPopup1 = this.dialog.open(this.uploadImagesPopup1, this.uploadImagesPopupConfig);
  }

  imageExtention: any;
  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  uploadErrorMsg: any;
  uploadErrorIcon: any;
  uploadRequiredMsg: any;
  uploadRequiredIcon: any;
  uploaderrorsizeIcon: any;
  uploaderrorsizeMsg: any;

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    const maxSizeInBytes: number = 1 * 1024 * 1024; // 5 MB

    if (file.size > maxSizeInBytes) {
      alert('File size exceeds the limit (5MB). Please choose a smaller file.');
      return;
    }

    // Proceed with your file upload logic here
  }

  uploadImagesValidation() {
    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    // this.uploaderrorsizeIcon = document.getElementById('logo-errorsize-icon') as HTMLInputElement;

    // this.uploaderrorsizeMsg = document.getElementById('logo-errorsize-msg') as HTMLInputElement;

    if (this.imageToUpload == null || this.imageToUpload == undefined) {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      // this.uploaderrorsizeIcon.style.display = 'none';
      // this.uploaderrorsizeMsg.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'block';
      this.uploadRequiredIcon.style.display = 'block';
    }
  }

  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  dataValues: any = {};
  logosizeextended = false;
  uploadLogoImage() {
    this.isProcessing = true;
    if (this.imageToUpload == null || this.imageToUpload == undefined) {
      this.uploadImagesValidation();
      this.isProcessing = false;
    } else if (this.imageUploadFlag == "Organization") {
      if (this.oneQmsOrgImagesDetails != null || this.oneQmsOrgImagesDetails != undefined) {
        this.dataValues = {
          operation: 'U',
          logoImageExt: this.imageExtention
        };
        const uploadLogoData = new FormData();

        uploadLogoData.append('binaryLogoFile', this.imageToUpload);
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        uploadLogoData.append('oneQmsOrgImagesDto', blob);
        this.appService.updateLogoImage(uploadLogoData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup1.close();
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {
        this.dataValues = {
          operation: 'I',
          logoImageExt: this.imageExtention
        };
        const addLogoData = new FormData();
        addLogoData.append('binaryLogoFile', this.imageToUpload);
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        addLogoData.append('oneQmsOrgImagesDto', blob);
        this.appService.addLogoImage(addLogoData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup1.close();
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }
    } else {
      if (this.oneQmsOrgUsersDetails != null || this.oneQmsOrgUsersDetails != undefined) {
        this.dataValues = {
          operation: 'U',
          userImageExtn: this.oneQmsOrgUsersDetails.imageExtention
        };
        const uploadLogoData = new FormData();
        uploadLogoData.append('file', this.imageToUpload);
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        uploadLogoData.append('oneQmsUserDetailsDto', blob);
        this.appService.updateUserImage(uploadLogoData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup1.close();
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {
        this.dataValues = {
          operation: "I",
          userImageExtn: this.imageExtention
        };
        const addLogoData = new FormData();
        addLogoData.append('file', this.imageToUpload);
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        addLogoData.append('oneQmsUserDetailsDto', blob);
        this.appService.addUserImage(addLogoData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup1.close();
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }
    }
  }

  cancelUploadLogoFunction() {
    this.imageToUpload = null;
    this.visibleUploadImagesPopup1.close();
  }

  uploadImages(e: any) {

    // this.onFileSelected(e);
    this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();

    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    //this.uploaderrorsizeIcon = document.getElementById('logo-errorsize-icon') as HTMLInputElement;

    // this.uploaderrorsizeMsg = document.getElementById('logo-errorsize-msg') as HTMLInputElement;
    // this.uploaderrorsizeIcon.style.display = 'none';
    //   this.uploaderrorsizeMsg.style.display = 'none';

    if (this.imageExtention != "jpg" && this.imageExtention != "png" && this.imageExtention != "jpeg") {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'block';
      this.uploadErrorIcon.style.display = 'block';
      // this.uploaderrorsizeIcon.style.display = 'none';
      //this.uploaderrorsizeMsg.style.display = 'none';
      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    } else {

      // this.uploaderrorsizeIcon.style.display = 'none';
      // this.uploaderrorsizeMsg.style.display = 'none';

      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    }

    const file: File = e.target.files[0];
    this.imageToUpload = file;
    const maxSizeInBytes: number = 1 * 500 * 500; // 5 MB
    let FileSizeAllowToupload = false;
    if (file.size > maxSizeInBytes) {

      //   this.uploaderrorsizeMsg.style.display = 'block';
      // this.uploaderrorsizeIcon.style.display = 'block';
      this.logosizeextended = true;

      FileSizeAllowToupload = true;
    }


    if (file && !FileSizeAllowToupload) {
      let name = file.name.substr(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file == undefined ? '' : file);
      formData.append("pageName", "IMAGE");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.uploadSuccessMsg.style.display = 'block';
            this.uploadSuccessIcon.style.display = 'block';
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        })
    }
  }

  title: any;
  downloadDocFunc() {
    this.title = "Download";
    this.visibleBulkDownloadPopup.close();
    this.visibleSDownloadPopup = this.dialog.open(this.downloadPopup, this.propertiesdownloadPopupConfig);
  }


  visibleSDownloadPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('downloadPopup', { static: true }) downloadPopup: TemplateRef<any>;
  propertiesdownloadPopupConfig = {
    width: '1200px',
    minHeight: '60vh',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  changeInChild1(event: any) {
    if (event) {
      this.visibleSDownloadPopup.close();
    }
  }


  cancelDownloadFunction() {
    this.visibleSDownloadPopup.close();
  }


  visibleCrInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  crInfoPopupConfig = {
    width: '500px',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };
  okInfo() {
    this.visibleCrInfoPopup.close();
  }


  downloadSavedReport(list: any) {
    this.isProcessing = true;
    this.appService.downloadSavedReport(
      list.reportId, list.reportName);
    this.isProcessing = false;
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  loggedUserId: any;
  dropDownForAuditGroup: any = [];
  navigate(quickAccess: any) {

    this.isProcessing = true;
    this.message.taskLevelData = {};
    this.qmsservice.cancelButtonFrom = "MyTask";
    this.qmsservice.taskModuleName = quickAccess.module;
    this.qmsservice.moduleName = quickAccess.module;
    this.qmsservice.activityId = quickAccess.taskId;
    this.message.activityId = quickAccess.taskId;
    this.message.showLeftMenu = 'Main';

    switch (quickAccess.module) {

      case 'CR':
        if (quickAccess.taskId == 0 && quickAccess.page == "Report") {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          this.message.changeRequestCode = "CR";
          this.qmsservice.moduleName = "CR";
          this.router.navigate(['/dashboard/ActivityReportComponent', "CR"]);
        } else if (quickAccess.taskId == 0) {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          //this.router.navigate(['/dashboard/ActivityCR', quickAccess.module]);
        } else {
          this.appService.getCrByCrNo(quickAccess.taskId).subscribe((activityData: any) => {
            this.qmsservice.activity = activityData;
            this.qmsservice.selectedActivityGroupId = activityData.groupId;
            this.qmsservice.selectedGroup = activityData.groupId;
            this.activityNavigation(quickAccess, activityData);
          })
        }

        break;

      case 'CAPA':
        if (quickAccess.taskId == 0 && quickAccess.page == "Report") {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.message.isTagHomeFromHome = true;
          this.topNavigationComponent.newgetcall();
          this.message.changeRequestCode = "CAPA";
          this.qmsservice.moduleName = "CAPA";
          this.router.navigate(['/dashboard/ActivityReportComponent', "CAPA"]);
        } else if (quickAccess.taskId == 0) {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          //this.router.navigate(['/dashboard/ActivityCR', quickAccess.module]);
        } else {
          this.appService.getCapaVwDetailsByCapaNo(quickAccess.taskId).subscribe((activityData: any) => {
            this.qmsservice.activity = activityData;
            this.qmsservice.selectedActivityGroupId = activityData.groupId;
            this.qmsservice.selectedGroup = activityData.groupId;
            this.activityNavigation(quickAccess, activityData);
          })
        }

        break;

      case 'DV':
        if (quickAccess.taskId == 0 && quickAccess.page == "Report") {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.message.isTagHomeFromHome = true;
          this.topNavigationComponent.newgetcall();
          this.message.changeRequestCode = "DV";
          this.qmsservice.moduleName = "DV";
          this.router.navigate(['/dashboard/ActivityReportComponent', "DV"]);
        } else if (quickAccess.taskId == 0) {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          //this.router.navigate(['/dashboard/ActivityCR', quickAccess.module]);
        } else {
          this.appService.getDvByDvNo(quickAccess.taskId).subscribe((activityData: any) => {
            this.qmsservice.activity = activityData;
            this.qmsservice.selectedActivityGroupId = activityData.groupId;
            this.qmsservice.selectedGroup = activityData.groupId;
            this.activityNavigation(quickAccess, activityData);
          })
        }

        break;

      case 'IN':
        if (quickAccess.taskId == 0 && quickAccess.page == "Report") {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.message.isTagHomeFromHome = true;
          this.topNavigationComponent.newgetcall();
          this.message.changeRequestCode = "IN";
          this.qmsservice.moduleName = "IN";
          this.router.navigate(['/dashboard/ActivityReportComponent', "IN"]);
        } else if (quickAccess.taskId == 0) {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          //this.router.navigate(['/dashboard/ActivityCR', quickAccess.module]);
        } else {
          this.appService.getIncidentDetailsByInNo(quickAccess.taskId).subscribe((activityData: any) => {
            this.qmsservice.activity = activityData;
            this.qmsservice.selectedActivityGroupId = activityData.groupId;
            this.qmsservice.selectedGroup = activityData.groupId;
            this.activityNavigation(quickAccess, activityData);
          })
        }

        break;

      case 'QI':
        if (quickAccess.taskId == 0 && quickAccess.page == "Report") {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.message.isTagHomeFromHome = true;
          this.topNavigationComponent.newgetcall();
          this.message.changeRequestCode = "QI";
          this.qmsservice.moduleName = "QI";
          this.router.navigate(['/dashboard/ActivityReportComponent', "QI"]);
        } else if (quickAccess.taskId == 0) {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          //this.router.navigate(['/dashboard/ActivityCR', quickAccess.module]);
        } else {
          this.appService.getQiVwDetailsByQiNo(quickAccess.taskId).subscribe((activityData: any) => {
            this.qmsservice.activity = activityData;
            this.qmsservice.selectedActivityGroupId = activityData.groupId;
            this.qmsservice.selectedGroup = activityData.groupId;
            this.activityNavigation(quickAccess, activityData);
          })
        }

        break;

      case 'CC':
        if (quickAccess.taskId == 0 && quickAccess.page == "Report") {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.message.isTagHomeFromHome = true;
          this.topNavigationComponent.newgetcall();
          this.message.changeRequestCode = "CC";
          this.qmsservice.moduleName = "CC";
          this.router.navigate(['/dashboard/ActivityReportComponent', "CC"]);
        } else if (quickAccess.taskId == 0) {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          //this.router.navigate(['/dashboard/ActivityCR', quickAccess.module]);
        } else {
          this.appService.getCcDetailsByCcNo(quickAccess.taskId).subscribe((activityData: any) => {
            this.qmsservice.activity = activityData;
            this.qmsservice.selectedActivityGroupId = activityData.groupId;
            this.qmsservice.selectedGroup = activityData.groupId;
            this.activityNavigation(quickAccess, activityData);
          })
        }

        break;

      case 'AU':
        if (quickAccess.taskId == 0 && quickAccess.page == "Report") {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.message.isTagHomeFromHome = true;
          this.topNavigationComponent.newgetcall();
          this.message.changeRequestCode = "AU";
          this.qmsservice.moduleName = "AU";
          this.router.navigate(['/dashboard/ActivityReportComponent', "AU"]);
        } else if (quickAccess.taskId == 0) {
          this.qmsservice.showTopNav = true;
          this.qmsservice.topNavModule = "Quality";
          this.topNavigationComponent.newgetcall();
          //this.router.navigate(['/dashboard/ActivityCR', quickAccess.module]);
        } else {
          this.appService.getAuByAuNo(this.qmsservice.activityId).subscribe((data: any) => {
            this.auService.isAuditor = data.leadAuditor == this.message.getUserId();
            this.qmsservice.activity = data;
            this.qmsservice.selectedActivityGroupId = this.qmsservice.selectedGroup = data.groupId;
            this.qmsservice.activityId = this.message.activityId = quickAccess.TASK_NO;
            this.auService.auditPageFrom = "MyTask";
            this.qmsservice.auditEditmodeDatas = { pageName: "" };
            this.isProcessing = false;
            this.qmsservice.activityDynamicButtonList = [];
            this.auService.tabName = 'Conduct Audit';
            this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
            //this.auComponent.ngOnInit();
            this.qmsservice.cancelButtonFrom = "myTask";
            this.appService.getQmsGroupDetailsByModule(data.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
              this.qmsservice.selectedGroupDetailData = data1;
            });
            this.appService.getQmsActiveUserByGroupIdModuleUserId(data.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
              this.qmsservice.userRole = response1;
              this.selectedGroupValue = [{
                valueExp: this.qmsservice.userRole[0].groupId,
                displayExp: this.qmsservice.userRole[0].groupName
              }];
              this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
              this.qmsservice.groupNameAndValue = this.selectedGroupValue;
              this.qmsservice.selectedGroupDetailId = response1[0].groupDetailId;
              if (this.qmsservice.userRole[0]?.qmsRoles.includes("Auditor")) {
                this.qmsservice.loggedAuditor = true;
              } else {
                this.qmsservice.loggedAuditor = false;
              }

              this.qmsservice.auditEditmodeDatas = { pageName: "Conduct Audit" };
              let list: any = {};
              this.message.activityId = this.qmsservice.activityId = list.AU_NO = data.auNo;
              this.qmsservice.selectedActivityGroupId = list.GROUP_ID = data.groupId;
              this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedGroupValue[0].displayExp;
              this.message.breadcrumbData.fourthLevel = list.AU_ID = data.auId;
              this.qmsservice.activity = {};
              this.qmsservice.activity.status = list.STATUS = data.status;
              this.qmsservice.getQmsActionDataUsingById = {};
              this.router.navigate(['/dashboard/auDetailPage']);

            });
          })
        }


        break;

      case 'DMS':
        this.documentsNavigation(quickAccess);
        break;

      case 'FORMS':
        this.formsNavigation(quickAccess);
        break;
    }
  }


  activityNavigation(quickAccess: any, activityData: any) {

    const firstRequest$ = this.appService.getQmsGroupDetailsByModule(activityData.groupId, this.qmsservice.moduleName);
    const secondRequest$ = this.appService.getQmsActiveUserByGroupIdModuleUserId(activityData.groupId, this.qmsservice.moduleName);

    let thirdRequest$;

    if (quickAccess.module !== 'IN' && quickAccess.module !== 'CC') {
      thirdRequest$ = this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer');
    } else {
      thirdRequest$ = scheduled([null], asyncScheduler);
    }

    forkJoin([firstRequest$, secondRequest$, thirdRequest$]).subscribe({
      next: ([groupDetails, groupUsers, activeGroupUsers]) => {
        this.isProcessing = false;
        this.qmsservice.selectedGroupDetailData = groupDetails;
        this.qmsservice.userRole = groupUsers;
        this.qmsservice.selectedGroupDetailId = this.qmsservice.userRole[0]?.groupDetailId;
        this.qmsservice.loggedInitiaor = this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator");
        // activeGroupUsers && (this.dropDownForOwner = activeGroupUsers, this.selectBoxForOwner());
        //this.subActivityNavigation(quickAccess, activityData);
        (this.processModuleRouting(quickAccess.module), this.message.breadcrumbData.fourthLevel = quickAccess.tagRef);
      },
      error: error => {
        console.error('Error:', error);
      }
    });
  }

  processModuleRouting(moduleCode: any) {
    switch (moduleCode) {
      case 'CR':
        this.router.navigate(['dashboard/qmsCr']);
        break;
      case 'CAPA':
        this.router.navigate(['dashboard/capa']);
        break;
      case 'DV':
        this.router.navigate(['dashboard/dv']);
        break;
      case 'IN':
        this.router.navigate(['dashboard/in']);
        break;
      case 'QI':
        this.router.navigate(['dashboard/qi']);
        break;
      case 'CC':
        this.router.navigate(['dashboard/cc']);
        break;
    }
  }

  documentData: any = {};
  folderData: any = {};
  breadCrumbList: any = [];
  documentsNavigation(quickAccess: any) {
    if (quickAccess.page == "Folder") {
      this.isProcessing = true;
      this.appService.getDmsFolderDataById(quickAccess.taskId)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.folderData = data[0];
          this.appService.setParentFolderId(this.folderData.folderId);
          this.breadCrumbList.push(this.folderData.folderName);
          this.appService.setDocumentBreadcrumbList(this.breadCrumbList);
          this.router.navigate(['/dashboard/subFolder', this.folderData.folderName]);
        })
    } else {
      this.isProcessing = true;
      this.appService.getDocumentByDocIdFirstTime(quickAccess.taskId).subscribe((data: any) => {
        this.documentData = data[0];
        this.isProcessing = false;
        this.appService.setParentFolderId(this.documentData.folderId);
        this.appService.getDocumentTypeBasedOnModule("DOCS").subscribe((data: any) => {
          this.dropDownFordocumentTypeList = data;
          this.isProcessing = false;
          this.router.navigate(['/dashboard/addDocument'],
            {
              state: {
                documentData: this.documentData,
                dropDownFordocumentTypeList: this.dropDownFordocumentTypeList
              }
            }
          );
        })
      })
    }

  }

  formObj: any = {};
  formsNavigation(quickAccess: any) {
    this.isProcessing = true;
    this.appService.getFormByFormId(quickAccess.taskId)
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.formObj = data[0];
        this.message.breadcrumbData.secondLevel = this.formObj.formName;
        this.message.breadcrumbData.thirdLevel = null;
        this.router.navigate(['/dashboard/formsAndLogsDetail'], {
          state: {
            formObj: this.formObj
          }
        });
      })
  }
  actionLabels: any = [];
  menuTopLeftPosition = { x: '0', y: '0' }
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  onRightClick(event: MouseEvent, item: any) {
    event.preventDefault();
    this.deleteTagData = item;
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';
    this.actionLabels = [{
      text: "Untag",
      icons: "fa fa-trash"
    }]
    this.matMenuTrigger.menuData = { item: this.actionLabels };
    this.matMenuTrigger.openMenu();
  }

  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;


  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };


  deleteTagData: any = {};
  deleteReason: any;
  performOperationFunc(data: any) {

    this.deleteReason = "";
    this.popupDataTitle.title = "Untag";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFunction() {
    let data = {

      taskId: this.deleteTagData.taskId,
      deleteReason: this.deleteReason,
      groupId: this.deleteTagData.groupId,
      page: this.deleteTagData.page,
      module: this.deleteTagData.module,
      tagRef: this.deleteTagData.tagRef,
      tagPermanently: this.deleteTagData.tagPermanently,
      operation: "UNTAG"
    }
    this.isProcessing = true;
    this.appService.deleteHomePageTags(data).subscribe((data: any) => {
      if (data.resultType == "S") {
        this.isProcessing = true;
        this.visibleDeletePopup.close();
        this.appService.getMyTags().subscribe((data: any) => {
          this.isProcessing = false;
          this.myTagsList = data;
        })
      } else {
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }
    })
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

}


